import { Typography } from '@gto/ui/typography'

type RulesListProps = {
  rules: string[]
}

export const RulesList = ({ rules }: RulesListProps) => (
  <ul className="m-0 list-inside list-disc p-0 text-text-secondary">
    {rules.map((rule, index) => (
      <li
        // eslint-disable-next-line @eslint-react/no-array-index-key -- static i18n rules list, render-once, never reorders
        key={index}
        className="mb-2"
      >
        <Typography
          color="text.secondary"
          variant="body3"
        >
          {rule}
        </Typography>
      </li>
    ))}
  </ul>
)
